<template><div><h1 id="kampagne-senden" tabindex="-1"><a class="header-anchor" href="#kampagne-senden"><span>Kampagne senden</span></a></h1>
<p>Kampagne senden — Versendet Kampagne</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Mit dieser Prozedur wird eine Kampagne versendet, zu Testzwecken kann die Kampagne auch an eine beliebige E-Mail Adresse versendet werden.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Datenaustausch → MailChimp → Kontextmenu → Kampagne senden...</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>Job-ID</dt>
<dd>Eindeutige fortlaufende Nummer für die Identifikation der Kampagne (wird vom System vergeben).</dd>
<dt>Kampagne</dt>
<dd>Bezeichnung der Kampagne</dd>
<dt>Senden</dt>
<dd>Definitiv = versendet die Kampagne an die Empfänger, Test = Versand an die eingetragene E-Mail Adresse unter &quot;E-Mail Adresse für Testversand&quot;.</dd>
<dt>E-Mail Adresse für Testversand</dt>
<dd>E-Mail Adresse an die die Kampagne zu Testzwecken versendet wird.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Protokoll vom Versand.</p>
<h2 id="welche-daten-werden-verwendet-input" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verwendet-input"><span>Welche Daten werden verwendet? (Input)</span></a></h2>
<p>E-Mail Adressen</p>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<p>Ereignisse zu Personen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/schnittstelle/mailchimp.html" title="6. MailChimp (E-Mail)">MailChimp (E-Mail)</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.mailchimp.html" title="MailChimp">MailChimp</RouteLink></p>
</div></template>


